"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("./utils/constants");
var _v2constants = require("./utils/v2constants");
var _Browser = require("../../utils/Browser");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Icon Component
 */
var Icon = function Icon(props) {
  var icons = props.icons,
    id = props.id,
    className = props.className,
    style = props.style,
    ariaControls = props.ariaControls,
    ariaExpanded = props.ariaExpanded,
    ariaLabel = props.ariaLabel,
    canReceiveFocus = props.canReceiveFocus,
    color = props.color;
  var iconClass = function iconClass() {
    return (0, _classnames["default"])({
      'ui-icon': true
    }, className);
  };
  var styles = (0, _lodash.isEmpty)(style) ? {
    svg: {
      display: 'inline-block',
      verticalAlign: 'middle',
      fill: className.includes('fill-current') ? '' : color || ''
    }
  } : style;
  var allIcons = _objectSpread(_objectSpread({}, _constants.ICONS), _v2constants.V2ICONS);
  var viewBox = (0, _lodash.get)(icons, 'icon.viewBox', null) || (0, _lodash.get)(allIcons, props.icon, {}).viewBox;
  var iconImage = (0, _lodash.get)(icons, 'icon.markup', null) || (0, _lodash.get)(allIcons, props.icon, {}).markup;
  if ((0, _lodash.isEmpty)(viewBox) || (0, _lodash.isEmpty)(iconImage)) {
    return /*#__PURE__*/_react["default"].createElement("p", null, "Icon viewBox or markup does not exist!");
  }
  if (props.onClick && !props.disabled) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      role: "button",
      "aria-controls": ariaControls,
      "aria-expanded": ariaExpanded,
      "aria-label": ariaLabel,
      onClick: props.onClick,
      tabIndex: canReceiveFocus ? 0 : -1,
      onKeyDown: (0, _Browser.navigateOnEnterOrSpace)(props.onClick)
    }, /*#__PURE__*/_react["default"].createElement("svg", {
      id: id,
      className: iconClass(),
      style: styles.svg,
      width: "".concat(props.size, "px"),
      height: "".concat(props.size, "px"),
      viewBox: viewBox
    }, iconImage));
  }
  return /*#__PURE__*/_react["default"].createElement("svg", {
    id: id,
    className: iconClass(),
    style: styles.svg,
    width: "".concat(props.size, "px"),
    height: "".concat(props.size, "px"),
    viewBox: viewBox,
    "aria-label": ariaLabel
  }, iconImage);
};
Icon.propTypes = {
  /** ariaLabel for a11y */
  ariaLabel: _propTypes["default"].string,
  /** ariaControls for a11y */
  ariaControls: _propTypes["default"].string,
  /** ariaExpanded for a11y */
  ariaExpanded: _propTypes["default"].bool,
  /** id for reference */
  id: _propTypes["default"].string,
  /** className for reference */
  className: _propTypes["default"].string,
  /** Icon name */
  icon: _propTypes["default"].string.isRequired,
  /** Color of icon */
  color: _propTypes["default"].string,
  /** Size of Icon */
  size: _propTypes["default"].number,
  /** clickable functionality. */
  onClick: _propTypes["default"].func,
  /**
   * An object of icons if coming directly from the application.
   */
  icons: _propTypes["default"].object,
  /** Override the inline-styles of the root element || Not Recommended */
  style: _propTypes["default"].object,
  /** Is the Icon disabled? */
  disabled: _propTypes["default"].bool,
  /** If the parent already has a tabIndex, this prop will allow you to change the tabIndex for Icon */
  canReceiveFocus: _propTypes["default"].bool
};
Icon.defaultProps = {
  ariaLabel: undefined,
  ariaControls: null,
  ariaExpanded: null,
  id: '',
  className: '',
  icon: '',
  color: '',
  size: 16,
  onClick: null,
  icons: {},
  style: {},
  disabled: false,
  canReceiveFocus: true
};
var _default = exports["default"] = Icon;